import React from "react";
import { Box } from "@mui/material";
import { NAVBAR_HEIGHT } from "../Header/Navbar/NavbarConstants";
import { Logo } from "../Header/Navbar/Logo";
import { HEADER_STYLES } from "../../styles/headerStyles";

export const CheckoutHeader: React.FC = () => {
  return (
    <>
      <Box
        id="checkout-navbar"
        sx={{
          ...HEADER_STYLES.fixedHeader,
          justifyContent: "center",
          height: NAVBAR_HEIGHT.checkout,
        }}
      >
        <Logo isScrolled={true} />
      </Box>
      
      <Box sx={HEADER_STYLES.spacer(NAVBAR_HEIGHT.checkout)} />
    </>
  );
};














